import { Button } from "@/components/ui/button";
import { Eye, Play, Download, Share, Trash2 } from "lucide-react";

interface DrillCardActionsProps {
  onPreview: () => void;
  onSelect: () => void;
  onDownload: () => void;
  onShare: () => void;
  onDelete: () => void;
}

export const DrillCardActions = ({
  onPreview,
  onSelect,
  onDownload,
  onShare,
  onDelete,
}: DrillCardActionsProps) => {
  return (
    <div className="flex gap-2">
      <Button
        variant="ghost"
        size="sm"
        className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
        onClick={onPreview}
      >
        <Eye className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="text-green-600 hover:text-green-700 hover:bg-green-50"
        onClick={onSelect}
      >
        <Play className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="text-purple-600 hover:text-purple-700 hover:bg-purple-50"
        onClick={onDownload}
      >
        <Download className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50"
        onClick={onShare}
      >
        <Share className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="text-red-600 hover:text-red-700 hover:bg-red-50"
        onClick={onDelete}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};